import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { MdMoreHoriz } from "react-icons/md";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { setSelectAdminArac } from "../../features/admin2/admin2Slice";
import { FaCheckCircle } from "react-icons/fa";
import { FaWindowClose } from "react-icons/fa";

const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      .detay {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        .more {
          color: ${({ theme }) => theme.mainTextColor} !important;
          font-size: 25px;
        }
      }
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 20px;
          }
        }
      }
    }
  }
`;

const KooperatifAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const handleOptions = (e) => {
    e.stopPropagation();
    dispatch(showModal("kooperatifAraclarOptions"));
    dispatch(setSelectAdminArac(data));
  };

  return (
    <Container theme={theme}>
      <div onClick={() => {dispatch(showModal("kooperatifAracDetay")); dispatch(setSelectAdminArac(data)); }} className="container">
        <div className="content">
          <div onClick={(e) => handleOptions(e)} className="detay">
            <MdMoreHoriz className="more" />
          </div>
          <div className="row">
            <div className="col">
              {data?.adSoyadUnvan}
            </div>
            <div className="col">
              {data?.phoneNumber ? data?.phoneNumber : "-"}
            </div>
            <div className="col">
              {data?.trailerPlate ? data?.trailerPlate : data?.truckPlateNumber}
            </div>
            <div className="col">
              {data?.truckType === "Römork" || data?.truckType === "Y.Römork"
                ? data?.trailerType
                : data?.truckSubType}
            </div>
            <div className="col">
              {data?.truckType === null ? data?.trailerType : data?.truckType}
            </div>
            <div className="col">
              {data?.truckType === "Römork" || data?.truckType === "Y.Römork"
                ? data?.trailerSubType
                : data?.trailerType}
            </div>
            
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KooperatifAraclarContainer;
